export enum IntegrationArea {
  IMAGING = 'IMAGING',
}
